/** True when href should use a native anchor (external / mailto), not React Router Link. */
export function isExternalLegalHref(href: string): boolean {
  return /^(https?:|mailto:)/i.test(href);
}
